export default __webpack_public_path__ + "static/media/road_img_7_7.7f803598.jpg";